import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { Role } from 'dashboard/models/role';
import { RolesFilterParams, setAllRoles, setRoles } from 'dashboard/redux/actions/roles';
import { ApiEndpoint, PaginationParams } from 'lib/interfaces/api';

export function loadAllRoles() {
  return async (dispatch: Dispatch) => {
    const rolesResponse = await SessionClientDashboard.listResource<Role, PaginationParams>(
      ApiEndpoint.Role,
      // TODO: (Lauren) this is hardcoded for now to allow for orgs with large number of roles to see all their roles
      // clean up when we improve the UX to allow for paginated role selection
      { page: { number: 1, size: 60 } },
    );

    const roles = rolesResponse.data;
    dispatch(setAllRoles(roles));
  };
}

export function loadRolesList({
  currentPage,
  pageSize,
  filters,
}: {
  currentPage: number;
  pageSize: number;
  filters: RolesFilterParams;
}) {
  return async (dispatch: Dispatch) => {
    const paramsFull = {
      ...createParamsForRoles(filters),
      page: {
        number: currentPage,
        size: pageSize,
      },
    };

    const { data: roles, meta: paginationParams } = await SessionClientDashboard.listResource<
      Role,
      PaginationParams
    >(ApiEndpoint.Role, paramsFull);

    dispatch(setRoles(roles, paginationParams));
  };
}

function createParamsForRoles(filters: RolesFilterParams) {
  const { omni } = filters;

  return {
    filter: {
      omni,
    },
  };
}
